/* Copyright Verge Technologies 2018
 * @file thankyou.modal.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React from 'react';
import { Link } from 'react-router-dom';
import ReactModal from 'react-modal';

const ThankYouModal = (props) => {
  return (
    <ReactModal isOpen={props.isOpen} className="modal-background" overlayClassName="modal-overlay">
      <div className="modal">
        <div className="inner">
          <a onClick={props.closeModal} className="close">
            <svg width="13px" height="13px" viewBox="0 0 13 13">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1.000000, -1.000000)" fill="#B1CEF0" fillRule="nonzero">
                  <polygon
                    transform="translate(7.135000, 7.036000) rotate(180.000000) translate(-7.135000, -7.036000) "
                    points="7.234 8.294 7.134 8.194 2.254 13.073 0.996 11.815 5.776 7.037 0.996 2.257 2.254 0.999 7.034 5.779 7.134 5.879 12.014 0.999 13.271 2.256 8.496 7.036 13.274 11.816 12.017 13.073"
                  />
                </g>
              </g>
            </svg>
          </a>
          <h4>We will be in contact with you shortly!</h4>
          <div className="form form-complete">
            <div className="control">
              <Link to="/" className="button button-green">
                Home
              </Link>
              <a onClick={props.closeModal} className="button button-line">
                Close
              </a>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default ThankYouModal;



// WEBPACK FOOTER //
// ./src/components/ThankYouModal/thankyou.modal.js